import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiData } from '@wix/da-bi/pkg/events';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton/SolidButton';
import { useIsCurrentUserDeviationAuthor } from '../../../../utils/hooks/useIsCurrentUserDeviationAuthor';
import { useFreeDownloadAction } from '../../../buttons/DownloadButton/hooks';
const DownloadButton = (_param)=>{
    var { deviation } = _param, rest = _object_without_properties(_param, [
        "deviation"
    ]);
    const { t } = useTranslation();
    const isAuthor = useIsCurrentUserDeviationAuthor(deviation);
    const freeDownloadAction = useFreeDownloadAction(deviation, isAuthor);
    return /*#__PURE__*/ React.createElement(SolidButton, _object_spread({
        variant: "main",
        size: "medium",
        onClick: freeDownloadAction.onClick,
        href: freeDownloadAction.href,
        biData: BiData({
            evid: 350,
            ispaiddownload: 0,
            deviationid: deviation.deviationId,
            sectionname: 'action_bar'
        })
    }, rest), t('actionbar.download'));
};
DownloadButton.displayName = 'DownloadButton';
export default DownloadButton;
